module.exports = __webpack_public_path__ + "media/press/blabla-158d8c4f.png";